import React from "react";

import { Badge, BadgeVariant } from "@/components/ui/Badge";

interface SkillCollectionEditorHeaderProps {
  versionNumber: number | null;
  saveButton: React.ReactNode;
}

export const SkillCollectionEditorHeader = ({
  versionNumber,
  saveButton,
}: SkillCollectionEditorHeaderProps) => (
  <div className="flex h-[40px] shrink-0 items-center justify-between">
    <div className="flex min-w-0 items-center gap-x-2 overflow-hidden">
      {versionNumber !== null && (
        <Badge variant={BadgeVariant.BLUE} text={`Editing Version ${versionNumber}`} />
      )}
    </div>
    <div className="shrink-0">{saveButton}</div>
  </div>
);
